import { module } from 'modujs'
import { GtagHandler } from '../app'

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'emit'
        }

        this.gtagEvent = this.getData('event')
    }

    emit() {

        if(!this.gtagEvent) {
            return
        }

        GtagHandler.emit(this.gtagEvent)
    }
}
